export const Cards = [
    {
        cardType: 'Task',
        // types here can be unplanned task, risk, delay or constraint
        description: 'Conduct an Urgent Meeting with the Customer',
        ID: 5,
        type: 'Regular Task',
        cost: 300,
        resources: { normal: 0, executive: 1, expensive: 1 },
        earnedValue: 2000,
        steps: 2,
        // steps can be number/ 2 string options: "last gate", "start"
        delayOptions: { optionOne: null, optionTwo: null },
        firstOption: 'Execute Task',
        // this string meant for what will be written on the button but the first
        // option will always be the one that says "do the card"
        secondOption: 'Take a Delay Card',
        // this string meant for what will be written on the button but the second
        // option will always be the one that says "cant do the card/take delay"
    },
    {
        cardType: 'Constraint',
        // types here can be unplanned task, risk, delay or constraint
        description:
            'You are required to finish the project one month earlier and also cut down on personnel for the project. Advance 3 spaces and return 2 regular resources and 1 senior resource to the resource pool. If you do not have the necessary resources, take a delay card and remain where you are.',
        ID: 18,
        type: 'Regular Constraint',
        cost: 0,
        resources: { normal: 2, executive: 1, expensive: 0 },
        earnedValue: 0,
        steps: 3,
        // steps can be number/ 2 string options: "last gate", "start"
        delayOptions: { optionOne: null, optionTwo: null },
        firstOption: 'Execute Constraint',
        // this string meant for what will be written on the button but the first
        // option will always be the one that says "do the card"
        secondOption: 'Take a Delay Card',
        // this string meant for what will be written on the button but the second
        // option will always be the one that says "cant do the card/take delay"
    },
    {
        cardType: 'Risk',
        // types here can be unplanned task, risk, delay or constraint
        description:
            'Risk of significant increase in the project scope due to new technology. Go back 2 steps and allocate 1 senior resource and 1 expensive resource to deal with the risk. If you reach a gate or milestone, do not receive the budget or resources from them. If you do not have the resources required to handle the risk, take a delay card and remain on the space.',
        ID: 2,
        type: 'Regular Risk',
        cost: 0,
        resources: { normal: 0, executive: 1, expensive: 1 },
        earnedValue: 2000,
        steps: 2,
        // steps can be number/ 2 string options: "last gate", "start"
        delayOptions: { optionOne: null, optionTwo: null },
        firstOption: 'Execute Risk',
        // this string meant for what will be written on the button but the first
        // option will always be the one that says "do the card"
        secondOption: 'Take a Delay Card',
        // this string meant for what will be written on the button but the second
        // option will always be the one that says "cant do the card/take delay"
    },
    {
        cardType: 'Delay',
        description:
            'Choose a planned task that you have already completed and do it over before the end of the game OR Deduct 500 from the value earned to your project (execution a task for a second time does not earn value again nor progress)',
        ID: 7,
        type: 'Regular Delay',
        cost: 0,
        resources: { normal: 0, executive: 0, expensive: 0 },
        earnedValue: 0,
        steps: 0,
        delayOptions: {
            optionOne: ' Planned Task Again',
            optionTwo: 'Deduct 500 from Value',
        },
        firstOption: 'plannedTask',
        // on delays the option need to be string that symbol to the machine
        // which thing to preform according to the text in option 1 , on the button will be written always "execute option one"
        secondOption: 'earnedValue',
        // on delays the option need to be string that symbol to the machine
        // which thing to preform according to the text in option 2 , on the button will be written always "execute option two"
    },
];
